import { Layout } from "@/components/Layout";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_layout/_main/_centered")(
  {
    component: () => (
      <Layout>
        <Outlet />
      </Layout>
    ),
  },
);
